import type { Scalar } from 'src/tpbp-core/models/global.type'
import type { ProxyRecord } from 'src/services/deserializers/deserializers.types'
import type { ConditionCallback } from 'src/services/mappings/jsonSchema/jsonSchema.types'
import type {
  FieldStatus,
  FieldStatusesByOriginKey,
} from 'src/tpbp-core/models/fields/fieldRules.const'

export type EvaluatorCondition = {
  conditionCb: ConditionCallback
  status: FieldStatus
  enums: Scalar[]
}

class PropertyEvaluatorClass {
  conditions: EvaluatorCondition[] = []

  propertyKey: any = undefined

  constructor(propertyKey) {
    this.propertyKey = propertyKey
    this.conditions = []
  }

  appendCondition(condition: EvaluatorCondition) {
    this.conditions.push(condition)
  }

  getFirstValidCondition(
    record: ProxyRecord,
    fieldStatusesByOriginKey: FieldStatusesByOriginKey,
  ) {
    return this.conditions.find((condition) =>
      condition.conditionCb(record, fieldStatusesByOriginKey),
    )
  }

  getFieldStatus(
    record: ProxyRecord,
    fieldStatusesByOriginKey: FieldStatusesByOriginKey,
  ) {
    const condition = this.getFirstValidCondition(
      record,
      fieldStatusesByOriginKey,
    )

    return condition?.status
  }
}

export { PropertyEvaluatorClass }
